/// <amd-module name="Test/TestPlansHubRefresh/KeyboardShortcutsModule/AuthorTabKeyboardShortcutProvider" />
import * as AuthorResources from "Test/TestPlansHubRefresh/Pivots/AuthorPivot/Resources";
import * as AuthorConstants from "Test/TestPlansHubRefresh/Pivots/AuthorPivot/AuthorConstants";
import { AuthorActions } from "Test/TestPlansHubRefresh/Pivots/AuthorPivot/Redux/AuthorActions";
import { TelemetryConstants } from "Test/TestPlansHubRefresh/TestHub/Constants";
import { TelemetryActions } from "Test/TestPlansHubRefresh/TestHub/Redux//TelemetryActions";
import { isAdvancedLicenseEnabled } from "Test/TestPlansHubRefresh/TestHub/Redux/TestHubRefresh/TestHubRefreshSelector";
import { TestSuiteType } from "TestPlanCommon/Contracts/TestPlan";
import { IVssKeyboardShortcutService } from "VSS/Platform/KeyboardShortcuts";
import { IAuthorPivotContextMenuParams, IAuthorPivotHeaderMenuParams } from "Test/TestPlansHubRefresh/AuthorPivotMenuService/AuthorPivotMenuService.types";
import { IVssPageContext, Services, VssService, IVssService } from "VSS/Platform/Context";
import { IListSelection } from "VSSUI/List";
import { ITestCaseItem } from "Test/TestPlansHubRefresh/Pivots/AuthorPivot/Redux/AuthorContracts";

export interface IAuthorTabKeyboardShortcutProvider extends IVssService {
    /**
     * Register keyboard shortcuts
     * @param params - Author Pivot Header Menu Parameters
     */
    registerKeyboardShortcuts(params: IAuthorPivotHeaderMenuParams): void;

    /**
     * Unregisters a group of keyboard shortcuts
     */
    unregisterKeyboardShortcuts(): void;
}

export class AuthorTabKeyboardShortcutProvider extends VssService implements IAuthorTabKeyboardShortcutProvider {
    protected pageContext: IVssPageContext;
    public _serviceStart(pageContext: IVssPageContext): void {
        super._serviceStart(pageContext);
        this.pageContext = pageContext;
    }

    public _serviceRestart(pageContext: IVssPageContext): void {
        super._serviceRestart(pageContext);
    }

    public registerKeyboardShortcuts(params: IAuthorPivotContextMenuParams) {
        const shortcutService = this.pageContext.getService<IVssKeyboardShortcutService>("IVssKeyboardShortcutService");
        shortcutService.registerShortcut(AuthorConstants.TestCaseWorkItemType, {
            combos: ["alt+e"],
            description: AuthorResources.AddExistingTestCases,
            action: () => {
                this.addExistingTestCases(params);
            }
        });

        shortcutService.registerShortcut(AuthorConstants.TestCaseWorkItemType, {
            combos: ["alt+n"],
            description: AuthorResources.NewTestCase,
            action: () => {
                this.addNewTestCase(params);
            }
        });

        shortcutService.registerShortcut(AuthorConstants.TestCaseWorkItemType, {
            combos: ["del"],
            description: AuthorResources.RemoveTestCase,
            action: () => {
                this.removeTestCasesOnDeleteKey(params);
            }
        });
    }

    public addExistingTestCases(params: IAuthorPivotHeaderMenuParams) {
        if (params.suiteType != TestSuiteType.DynamicTestSuite) {
            params.dispatch(AuthorActions.addExistingTestCases(params.planId, params.suiteId, params.areaPath));

            const telemetryPayload = {
                suiteId: params.suiteId,
                suiteType: params.suiteType,
                planId: params.planId,
                areaPath: params.areaPath,
                isAdvancedLicenseEnabled: isAdvancedLicenseEnabled
            };
            params.dispatch(TelemetryActions.publishTelemetry(TelemetryConstants.ADD_EXISTING_TEST_CASES_USING_KEYBOARD, telemetryPayload));
        }
    }

    public addNewTestCase(params: IAuthorPivotHeaderMenuParams) {
        if (params.suiteType != TestSuiteType.DynamicTestSuite) {
            params.dispatch(AuthorActions.openNewTestCaseWitForm(params.planId, params.suiteId, params.areaPath, params.iterationPath));

            const telemetryPayload = {
                suiteId: params.suiteId,
                suiteType: params.suiteType,
                planId: params.planId,
                areaPath: params.areaPath,
                isAdvancedLicenseEnabled: isAdvancedLicenseEnabled
            };
            params.dispatch(TelemetryActions.publishTelemetry(TelemetryConstants.ADD_TEST_CASES_USING_KEYBOARD, telemetryPayload));
        }
    }

    public removeTestCasesOnDeleteKey(params: IAuthorPivotContextMenuParams) {
        if (params.selection && params.testCases) {
            const props = {
                suiteId: params.suiteId,
                suiteType: params.suiteType,
                planId: params.planId,
                areaPath: params.areaPath
            };

            const testCaseIds: number[] = this._getSelectedTestCaseIds(params.selection, params.testCases);
            if (testCaseIds !== undefined && testCaseIds.length > 0) {
                var dialogResult = window.confirm(AuthorResources.RemoveTestCaseViaDeleteKeyConfirmDialogText);
                if (dialogResult) {
                    params.dispatch(AuthorActions.removeTestCasesFromSuite(props.planId, props.suiteId, testCaseIds, params.selection));
                }
            }
        }
    }

    private _getSelectedTestCaseIds(testCasesTableSelection: IListSelection, testCases: ITestCaseItem[]): number[] {
        let selectedtestCaseIds: number[] = [];
        const selectionLength = testCasesTableSelection.value.length;
        for (let i = 0; i < selectionLength; i++) {
            for (let j = testCasesTableSelection.value[i].beginIndex; j <= testCasesTableSelection.value[i].endIndex; j++) {
                selectedtestCaseIds.push(testCases[j].id);
            }
        }
        return selectedtestCaseIds;
    }

    public unregisterKeyboardShortcuts() {
        const shortcutService = this.pageContext.getService<IVssKeyboardShortcutService>("IVssKeyboardShortcutService");
        shortcutService.removeShortcutGroup(AuthorConstants.TestCaseWorkItemType);
    }
}
Services.add("AuthorTabKeyboardShortcutProvider", { serviceFactory: AuthorTabKeyboardShortcutProvider });
